// extracted by mini-css-extract-plugin
module.exports = {"banner":"MigrationBanner_banner__8FTZR","description":"MigrationBanner_description__FqAFo","actions":"MigrationBanner_actions___ZWjF"};